import React from 'react';
import Router from './pages/router'
import './App.css';
import "./theme/theme.default.css"

function App() {
//   var admin = require("firebase-admin");

// var serviceAccount = require("./pages/pcna-c2fc2-firebase-adminsdk-e2baw-50dacfe38b.json");

// admin.initializeApp({
//   credential: admin.credential.cert(serviceAccount),
//   databaseURL: "https://pcna-c2fc2.firebaseio.com"
// });
  return (
    <div className="App d-flex flex-column flex-root">
      
	  <Router />
		
    </div>
  );
}

export default App;
